import React, { useState } from 'react';
import Header from '@/Header';

const HeaderWithTabs = ({ children, isHeader = true, isLoaded = true, onChange, path = '', selected, tabs }) => {
  const [activeTab, setActiveTab] = useState(selected ? tabs.find(f => f.name === selected).name : tabs[0].name);

  const handleTabClick = tabName => {
    setActiveTab(tabName);
    onChange && onChange(tabName);
  };

  return (
    <>
      <Header isHeader={isHeader} path={path}>
        {children}
        {isLoaded &&
          <ul className="nav nav-tabs">
            {tabs.map((tab, index) => (
              <li className="nav-item" key={index}>
                <button
                  className={`nav-link ${activeTab === tab.name ? 'active' : ''}`}
                  onClick={() => handleTabClick(tab.name)}
                  style={{minHeight:'3.25rem'}}
                >
                  {tab.label}
                </button>
              </li>
            ))}
          </ul>
        }
      </Header>
      {isLoaded &&
        <div className="tab-content" style={{height: 'calc(100% - 50px)'}}>
          {tabs.map((tab, index) => (
            <div className={`tab-pane ${tab.tabPaneClassName || ''} ${activeTab === tab.name ? 'active' : ''}`} key={index}>
              {tab.content}
            </div>
          ))}
        </div>
      }
    </>
  );
};

export default HeaderWithTabs;
